import { Injectable } from "@angular/core";
import { User } from "app/@core/models/user";
import { HttpService } from "app/@core/services/http.service";
import { AppSettings } from "app/app-settings";
import { environment } from "environments/environment";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AccountService {
  constructor(private httpService: HttpService) {}

  login(username, password) {
    const body = {
      username: username,
      password: password,
      origin: environment.origin,
    };
    return this.httpService
      .post(environment.DASHBOARD_END_POINT + "/Master/login", body)
      .pipe(
        map((result) => Object.assign(new User(), result)),
        catchError(this.httpService.handleError.bind(this.httpService))
      );
  }

  isEnabled(role: string) {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    if (
      user &&
      user.user_roles
        .split(",")
        .filter((urole) => urole.toLowerCase() === role.toLocaleLowerCase()).length >
        0
    ) {
      return true;
    }
    return false;
  }

  checkForUnProcessedVideo() {
    return this.httpService
      .post(AppSettings.API_CHECK_FOR_UNPROCESSED_VIDEO, {})
      .pipe(
        map((result) => Object.assign(new User(), result)),
        catchError(this.httpService.handleError.bind(this.httpService))
      );
  }
  getOrganizations() {
    return this.httpService.get(AppSettings.API_GET_ORGANIZATIONS).pipe(catchError(this.httpService.handleError.bind(this.httpService)));
  }
}
